<template>
  <div class="calendar-container">
    <!-- 自定义标题 -->
    <div class="custom-calendar-title">{{ currentTitle }}</div>
    <FullCalendar :options="calendarOptions">
      <template v-slot:eventContent="arg">
        <b>{{ arg.timeText }}</b>
        <i>{{ arg.event.title }}</i>
      </template>
    </FullCalendar>
  </div>
</template>

<script>
import FullCalendar from "@fullcalendar/vue3";
import dayGridPlugin from "@fullcalendar/daygrid";

export default {
  components: {
    FullCalendar,
  },
  data: function () {
    return {
      currentTitle: "", // 用于存储当前标题
      calendarOptions: {
        plugins: [dayGridPlugin],
        weekends: true,
        events: [{ title: "段考", start: new Date() }],

        // 隐藏 FullCalendar 默认的标题栏
        headerToolbar: {
          start: "",
          center: "",
          end: "",
        },
        // ... 其他配置
      },
    };
  },
};
</script>

<style scoped>
.calendar-container {
  position: fixed;
  top: 150px;
  left: 330px;
  width: 1400px;
  height: 600px; /* 设置日历容器的高度 */
  overflow-y: auto; /* 启用垂直滚动 */
}

::v-deep .fc-scrollgrid {
  border: none !important;
}

::v-deep .fc-scrollgrid td {
  border: none !important;
}

::v-deep .fc-scrollgrid th {
  border: none !important;
}

/* 日期数字黑色文字 */
::v-deep .fc-daygrid-day-number {
  color: rgb(72, 69, 69) !important;
  text-decoration: none !important;
  font-weight: 300;
  text-align: center !important;
  font-size: 14px !important;
  margin: 10px !important;
}

::v-deep .fc-col-header-cell-cushion {
  color: rgb(0, 0, 0);
  text-decoration: none !important;
  font-weight: 500;
  font-size: 14px !important;
  margin: 10px !important;
}

/* 设置当前日期的背景色为灰色 */
::v-deep .fc-day-today {
  background-color: #afacb3 !important; /* 灰色背景 */
}

/* 事件标题和时间的黑色文字 */
::v-deep .fc-event-title {
  color: rgb(0, 0, 0) !important; /* 黑色 */
}

/* 如果使用的是 b 和 i 标签来显示事件的时间和标题 */
::v-deep b {
  color: rgb(0, 0, 0) !important; /* 黑色 */
}

::v-deep i {
  color: rgb(0, 0, 0) !important; /* 黑色 */
}
</style>
